import angular from 'angular';
import assetFinanceModal from './assetFinanceModal';

export default angular
  .module('components.assetFinanceModal', [])
  .component('assetFinanceModal', assetFinanceModal).name;
